import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=482f8c79&scoped=true&lang=pug"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=482f8c79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f8c79",
  null
  
)

export default component.exports